export const clearSubscriptionNudgePopupTimer = () => {
  if (typeof window !== 'undefined' && window.avodNudgeHandler) {
    clearTimeout(window.avodNudgeHandler);
    window.avodNudgeHandler = null;
  }
};
